<template>
  <basic-dialog :show="show" @close="$emit('close')" maxWidth="700">
    <template v-slot:title>New Tenant</template>
    <v-row>
      <v-col cols="5">
        <v-text-field label="Name" v-model="name" :outlined="outlinedInputs" />
      </v-col>
      <v-col cols="5">
        <v-text-field
          label="Domain"
          v-model="domain"
          :outlined="outlinedInputs"
        />
      </v-col>
      <v-col cols="2">
        <v-text-field
          label="Max Users"
          v-model="maxUsers"
          :outlined="outlinedInputs"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-textarea label="Notes" v-model="notes" :outlined="outlinedInputs" />
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <h3 class="mt-4">Admin Account</h3>
    <v-row>
      <v-col>
        <v-text-field
          label="Username"
          v-model="username"
          :outlined="outlinedInputs"
        />
      </v-col>
      <v-col>
        <v-text-field
          label="Password"
          v-model="password"
          :outlined="outlinedInputs"
          type="password"
        />
      </v-col>
      <v-col>
        <v-text-field
          label="Email"
          v-model="email"
          :outlined="outlinedInputs"
        />
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Create</v-btn>
    </template>
    <div v-if="debug">
      <code>{{ maxUsers }}</code>
    </div>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog.vue";
export default {
  name: "new-tenant-dialog",
  components: { BasicDialog },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    value: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      debug: false,
      name: this.value ? this.value.name : "",
      email: this.value ? this.value.email : "",
      domain: this.value ? this.value.domain : "",
      notes: this.value ? this.value.notes : "",
      maxUsers: this.value ? this.value.maxUsers : 10,
      username: this.value ? this.value.username : "",
      password: this.value ? this.value.password : "",
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValid() {
      return (
        this.name && this.domain && this.username && this.password && this.email
      );
    },
  },

  watch: {
    value(newVal) {
      this.name = newVal ? newVal.name : "";
      this.domain = newVal ? newVal.domain : "";
      this.notes = newVal ? newVal.notes : "";
      this.maxUsers = newVal ? newVal.maxUsers : 10;
      this.username = newVal ? newVal.username : "";
      this.password = newVal ? newVal.password : "";
      this.email = newVal ? newVal.email : "";
    },
  },

  methods: {
    onSave() {
      this.$emit("input", {
        name: this.name,
        domain: this.domain,
        notes: this.notes,
        maxUsers: Number(this.maxUsers),
        username: this.username,
        password: this.password,
        email: this.email,
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/admin/user-access-controls/NewTenantDialog.vue